/*
 * initEditor 
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { loader, Monaco } from "@monaco-editor/react";
//import monaco from "monaco-editor";
import { adapptioDarkMonacoTheme } from "./themes";
import {
	ExpressionMonarchTokens,
	ExpressionMonarchTokens_Interpolation
} from "@adapptio/lib-blueprint";

function defineThemes(monaco: Monaco): void {
	monaco.editor.defineTheme("adapptioDark", adapptioDarkMonacoTheme);
}

// @todo Jirka Figure out how to handle global code completions
// function registerYaml(monaco: Monaco): void {
// 	monaco.languages.registerCompletionItemProvider("yaml", {
// 		triggerCharacters: [".", " "],
// 		provideCompletionItems: (model, position) => {

// 			const completion = this.dCtx.getCompletion("file://test", {
// 				line: position.lineNumber - 1,
// 				col: position.column - 1
// 			});

// 			// const prefix = model.getValueInRange({
// 			// 	startLineNumber: completion.range.start.line + 1,
// 			// 	startColumn: completion.range.start.col + 1,
// 			// 	endLineNumber: completion.range.end.line + 1,
// 			// 	endColumn: completion.range.end.col + 1
// 			// });

// 			return {
// 				suggestions: completion.items
// 					? completion.items.map((item) => {

// 						// const value = item.label.substr((position.column - 1) - completion.startColumn);
// 						// const offset = (completion.range.start.col) - (position.column);
// 						const value = (item.insertText !== undefined ? item.insertText : item.label);

// 						// console.log("XXX '" + prefix + "'", completion);
// 						console.log("Completions", completion, value);

// 						return {
// 							kind: item.kind as unknown as monaco.languages.CompletionItemKind,
// 							label: item.label,
// 							insertText: value,
// 							filterText: value,
// 							range: {
// 								// startLineNumber: position.lineNumber,
// 								// startColumn: completion.range.start.col + 1,
// 								// endLineNumber: position.lineNumber,
// 								// endColumn: completion.range.end.col + 1
// 								startLineNumber: position.lineNumber,
// 								startColumn: position.column,
// 								endLineNumber: position.lineNumber,
// 								endColumn: position.column
// 							}
// 						}
// 					})
// 					: []
// 			}
// 		}
// 	});

// 	monaco.languages.registerHoverProvider("yaml", {
// 		provideHover: (model, position) => {

// 			const completion = this.dCtx.getCompletion("file://test", {
// 				line: position.lineNumber - 1,
// 				col: position.column - 1
// 			});

// 			return {
// 				contents: [{
// 					value: JSON.stringify(completion, null, 2)
// 				}]
// 			}
// 		}
// 	});
// }

function registerExpression(monaco: Monaco): void {
	monaco.languages.register({
		id: "adapptioExpression"
	});

	monaco.languages.register({
		id: "adapptioExpressionInterpolation"
	});

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	monaco.languages.setMonarchTokensProvider("adapptioExpression", ExpressionMonarchTokens as any);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	monaco.languages.setMonarchTokensProvider(
		"adapptioExpressionInterpolation",
		ExpressionMonarchTokens_Interpolation as any
	);
}

export function initEditor(): void {
	loader.init().then((monaco) => {
		defineThemes(monaco);
		// @todo Enable when issues with global completion are resolved
		// registerYaml(monaco);
		registerExpression(monaco);
	});
}
